<mat-nav-list style="overflow: hidden;">
    <img [src]="createImgPath(imageServerPath)" (error)="onImgError($event)" alt="Logo" class="login-logo"
        routerLink="/All/dashboardCompo" />
    <mat-accordion>
        <mat-nav-list>
            <div class="nav-item active">
                <a class="nav-link" mat-list-item (click)="closeVendorsPanel()" routerLink="/AllVendor/vendorDashboard"
                    routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
                    <mat-icon class="nav-icon">home</mat-icon>
                    Dashboard
                </a>
            </div>

            <div class="nav-item">
                <mat-expansion-panel #vendorsPanel [class.mat-elevation-z0]="true">
                    <mat-expansion-panel-header routerLinkActive="active-list-item">
                        <mat-icon class="nav-icon">persons</mat-icon> Business Profile
                    </mat-expansion-panel-header>
                    <mat-nav-list>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/AllVendor/vendorPublicDetails"
                                routerLinkActive="active-list-item">
                                <li>Public Details</li>
                            </a>
                        </div>
                    </mat-nav-list>
                </mat-expansion-panel>
            </div>

            <div class="nav-item">
                <mat-expansion-panel #vendorsPanel1 [class.mat-elevation-z0]="true" (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false">
                    <mat-expansion-panel-header routerLinkActive="active-list-item">
                        <mat-icon class="nav-icon">payments</mat-icon>Payments
                    </mat-expansion-panel-header>
                    <mat-nav-list>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/AllVendor/vendorPaymentTrans"
                                routerLinkActive="active-list-item">
                                <li>Payment Transactions</li>
                            </a>
                        </div>
                    </mat-nav-list>
                </mat-expansion-panel>
            </div>

            <div class="nav-item">
                <a class="nav-link" mat-list-item (click)="closeVendorsPanel()" routerLink="/AllVendor/vendorRefund"
                    routerLinkActive="active-list-item">
                    <span class="material-icons" style="margin-right:10%">
                        monetization_on
                    </span>
                    Refunds
                </a>
            </div>
        </mat-nav-list>
    </mat-accordion>
</mat-nav-list>